import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { PercentWithUnit, PercentWithUnitSkeleton } from 'components/shared/Percent/PercentWithUnit';
import type { IntlKey } from 'locales';
import { ReactNode } from 'react';

type PercentWithUnitFieldProps = {
  value?: number;
  onChange?: (newTradingPrice: number | undefined) => void;
  isDisabled?: boolean;
  isReadOnly?: boolean;
  isLoading: boolean;
  id: string;
  labelKey?: IntlKey;
  unit?: string;
  children?: ReactNode;
  className?: string;
};

export function PercentWithUnitField({
  value,
  onChange,
  isDisabled,
  isReadOnly,
  isLoading,
  id,
  labelKey,
  unit,
  children,
  className,
}: PercentWithUnitFieldProps) {
  return (
    <BlockOrientationFormGroup inputId={id} label={labelKey}>
      {isLoading ? (
        <PercentWithUnitSkeleton />
      ) : (
        <PercentWithUnit
          isDisabled={isDisabled}
          isReadOnly={isReadOnly}
          e2e={id}
          hasError={false}
          value={value}
          onChange={onChange}
          precision={4}
          unit={unit}
          className={className}
        >
          {children}
        </PercentWithUnit>
      )}
    </BlockOrientationFormGroup>
  );
}
